import { render } from "./pgmx.vue?vue&type=template&id=2aa9fda6&scoped=true&ts=true"
import script from "./pgmx.vue?vue&type=script&lang=ts"
export * from "./pgmx.vue?vue&type=script&lang=ts"

import "./pgmx.vue?vue&type=style&index=0&id=2aa9fda6&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa9fda6"]])

export default __exports__